/**
 * Canonical screen geometry. canvas.ts, hud.ts, and radar.ts all
 * read from here so the play area and sidebar stay in agreement.
 *
 * Layout (640 x 480 canvas):
 *   +----------------------+--------+
 *   |       play area      |  side  |
 *   |     480 x 480        |  bar   |
 *   |                      | 160 x  |
 *   |                      | 480    |
 *   +----------------------+--------+
 */

export const LAYOUT = {
  canvasW: 640,
  canvasH: 480,
  playW: 480,
  playH: 480,
  sidebarX: 480,
  sidebarW: 160,
  sidebarH: 480,
} as const;
